export function removeBlankAtEnd(text) {
    let count = 0
    while (text[text.length - 1 - count] === ' '
        || text[text.length - 1 - count] === '\n') {
        count++
    }

    return text.slice(0, text.length - count)
}

export function ciEquals(a, b) {
    return typeof a === 'string' && typeof b === 'string'
        ? a.localeCompare(b, undefined, { sensitivity: 'base' }) === 0
        : a === b;
}

export function capitalizeText(text) {
    return text
        .split(' ')
        .map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
}

export function isValidText(text) {
    const regex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{}|\\:;"'<>,.?/~`]*$/
    return regex.test(text)
}

export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email)
}

export function truncateIfNecessary(text, length) {
    if (text.length > length) {
        return (text[length - 1] === ' ' ? text.slice(0, length - 1) : text.slice(0, length)) + '...'
    } else {
        return text
    }
}

export function setIfValidPrice(price, setPrice) {
    const inputVal = price.replace(',', '.');
    const regex = /^(\d*)([,.]\d{0,2})?$/;

    if (inputVal === "") {
        setPrice('0')

    } else if (regex.test(inputVal)) {
        setPrice(inputVal.at(0) === '0' && inputVal.length > 0 ? inputVal.slice(1,) : inputVal)
    }
}

export function formatTime(time) {
    const hour = parseInt(time.slice(0, 2))
    if (hour < 10) {
        return (time.slice(1, 2) + ':' + time.slice(2,) + ' AM')
    } else if (hour <= 12) {
        return (time.slice(0, 2) + ':' + time.slice(2,) + ' AM')
    } else {
        let newHour = 0
        switch (hour) {
            case 13:
                newHour = '1'
                break
            case 14:
                newHour = '2'
                break
            case 15:
                newHour = '3'
                break
            case 16:
                newHour = '4'
                break
            case 17:
                newHour = '5'
                break
            case 18:
                newHour = '6'
                break
            case 19:
                newHour = '7'
                break
            case 20:
                newHour = '8'
                break
            case 21:
                newHour = '9'
                break
            case 22:
                newHour = '10'
                break
            case 23:
                newHour = '11'
                break
            default:
                newHour = '00'
                break
        }

        return (newHour + ':' + time.slice(2,) + ' PM')
    }

}